import { render, staticRenderFns } from "./BadgeElement.vue?vue&type=template&id=1ac6c1f2&scoped=true&"
import script from "./BadgeElement.vue?vue&type=script&lang=ts&"
export * from "./BadgeElement.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeElement.vue?vue&type=style&index=0&id=1ac6c1f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac6c1f2",
  null
  
)

export default component.exports